/**
 * TEXTO PLANO → HTML DE EMAIL. Un párrafo por bloque separado con línea en blanco y <br> por salto
 * simple, con &, < y > escapados. Es la MISMA forma en que el servidor convierte el email congelado
 * de Review Estimate al mandarlo (`aHtml` en supplements/negotiation.ts): lo que se precarga en el
 * editor es lo que saldría.
 */
export function textoAHtml(texto: string): string {
  const esc = (s: string) => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  return texto.replace(/\r\n?/g, '\n').trim().split(/\n{2,}/)
    .map((p) => p.trim()).filter(Boolean)
    .map((p) => `<p>${esc(p).replace(/\n/g, '<br>')}</p>`)
    .join('');
}
